/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/255/interface/api
 */

import { message } from 'ant-design-vue'
import {
  collection_add_post,
  collection_listing_post,
  collection_browse_post,
  collection_detail_product_more_collectionId_post,
  collection_detail_product_show_add_post,
  collection_detail_product_show_delete_post,
  collection_detail_product_show_modify_post,
  collection_detail_collectionId_post,
  collection_excelImport_post,
  collection_invalid_post,
  collection_modify_post,
  collection_valid_post,
  collection_copy_post,
  collection_delete_post,
  collection_excelExport_post,
  collection_queryProductTagOrType_post,
  collection_preview_post,
  collection_detail_product_auto_show_modify_post,
  collection_detail_product_auto_show_delete_post,
  collection_collectionProductsExport_post,
  collection_invalidExport_post,
  collect_listing_post,
  collect_add_post,
  collect_invalid_post,
  collect_valid_post,
  collect_delete_post,
  collect_modify_post,
  collect_preview_post,
  collect_detail_product_more_collectId_post,
  collect_detail_product_auto_show_modify_post,
  collect_detail_product_auto_show_delete_post,
  collect_getLang_post,
  collect_excelExport_post,
  collect_detail_collectId_post,
  collect_browseSpu_post,
  collect_detail_product_show_delete_post,
  collect_detail_product_show_add_post,
  collect_detail_product_show_modify_post,
  collect_browseAutoSpu_post,
  collect_switchType_post,
  collect_queryProductTagOrType_post,
  collect_excelImport_post,
  collect_log_collectId_post,
  collect_autoManualInit_get,
  collect_browse_post,
  collect_copy_post,
  collect_mixmatch_detail_collectId_post,
  collect_pushShopify_post
} from 'server/modules/462'

// 新增分类
export const collection_add_post_ = async function(params) {
  const { success, data, retInfo } = await collection_add_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类列表
export const collection_listing_post_ = async function(params) {
  const { success, data, retInfo } = await collection_listing_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 浏览spu
export const collection_browse_post_ = async function(params) {
  const { success, data, retInfo } = await collection_browse_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类详情产品展示分页
export const collection_detail_product_more_collectionId_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await collection_detail_product_more_collectionId_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类-手动新增产品展示
export const collection_detail_product_show_add_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await collection_detail_product_show_add_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类-手动删除产品展示
export const collection_detail_product_show_delete_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await collection_detail_product_show_delete_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类详情-修改产品展示
export const collection_detail_product_show_modify_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await collection_detail_product_show_modify_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类详情
export const collection_detail_collectionId_post_ = async function(params) {
  const { success, data, retInfo } = await collection_detail_collectionId_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 批量导入
export const collection_excelImport_post_ = async function(params) {
  const { success, data, retInfo } = await collection_excelImport_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 关闭分类
export const collection_invalid_post_ = async function(params) {
  const { success, data, retInfo } = await collection_invalid_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 修改分类
export const collection_modify_post_ = async function(params) {
  const { success, data, retInfo } = await collection_modify_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 启用分类
export const collection_valid_post_ = async function(params) {
  const { success, data, retInfo } = await collection_valid_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类-复制
export const collection_copy_post_ = async function(params) {
  const { success, data, retInfo } = await collection_copy_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 删除分类
export const collection_delete_post_ = async function(params) {
  const { success, data, retInfo } = await collection_delete_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 导出
export const collection_excelExport_post_ = async function(params) {
  const { success, data, retInfo } = await collection_excelExport_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 自动-搜索商品tag或者Type
export const collection_queryProductTagOrType_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await collection_queryProductTagOrType_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 预览
export const collection_preview_post_ = async function(params) {
  const { success, data, retInfo } = await collection_preview_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类-自动-编辑产品展示
export const collection_detail_product_auto_show_modify_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await collection_detail_product_auto_show_modify_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类-自动-删除产品展示
export const collection_detail_product_auto_show_delete_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await collection_detail_product_auto_show_delete_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 导出
export const collection_collectionProductsExport_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await collection_collectionProductsExport_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 导出校验
export const collection_invalidExport_post_ = async function(params) {
  const { success, data, retInfo } = await collection_invalidExport_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类列表
export const collect_listing_post_ = async function(params) {
  const { success, data, retInfo } = await collect_listing_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 新增分类
export const collect_add_post_ = async function(params) {
  const { success, data, retInfo } = await collect_add_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 关闭分类
export const collect_invalid_post_ = async function(params) {
  const { success, data, retInfo } = await collect_invalid_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 启用分类
export const collect_valid_post_ = async function(params) {
  const { success, data, retInfo } = await collect_valid_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 删除分类
export const collect_delete_post_ = async function(params) {
  const { success, data, retInfo } = await collect_delete_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 修改分类
export const collect_modify_post_ = async function(params) {
  const { success, data, retInfo } = await collect_modify_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 预览
export const collect_preview_post_ = async function(params) {
  const { success, data, retInfo } = await collect_preview_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类详情产品展示分页
export const collect_detail_product_more_collectId_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await collect_detail_product_more_collectId_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类-自动-编辑产品展示
export const collect_detail_product_auto_show_modify_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await collect_detail_product_auto_show_modify_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类-自动-删除产品展示
export const collect_detail_product_auto_show_delete_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await collect_detail_product_auto_show_delete_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据站点获取语言
export const collect_getLang_post_ = async function(params) {
  const { success, data, retInfo } = await collect_getLang_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 导出
export const collect_excelExport_post_ = async function(params) {
  const { success, data, retInfo } = await collect_excelExport_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类详情
export const collect_detail_collectId_post_ = async function(params) {
  const { success, data, retInfo } = await collect_detail_collectId_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 手动预览
export const collect_browseSpu_post_ = async function(params) {
  const { success, data, retInfo } = await collect_browseSpu_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类-手动删除产品展示
export const collect_detail_product_show_delete_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await collect_detail_product_show_delete_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类-手动新增产品展示
export const collect_detail_product_show_add_post_ = async function(params) {
  const { success, data, retInfo } = await collect_detail_product_show_add_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类详情-修改产品展示
export const collect_detail_product_show_modify_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await collect_detail_product_show_modify_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 自动-手动维护预览
export const collect_browseAutoSpu_post_ = async function(params) {
  const { success, data, retInfo } = await collect_browseAutoSpu_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 切换分类类型
export const collect_switchType_post_ = async function(params) {
  const { success, data, retInfo } = await collect_switchType_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 自动-搜索商品tag或者Type
export const collect_queryProductTagOrType_post_ = async function(params) {
  const { success, data, retInfo } = await collect_queryProductTagOrType_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 批量导入
export const collect_excelImport_post_ = async function(params) {
  const { success, data, retInfo } = await collect_excelImport_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类日志
export const collect_log_collectId_post_ = async function(params) {
  const { success, data, retInfo } = await collect_log_collectId_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// autoManualInit
export const collect_autoManualInit_get_ = async function(params) {
  const { success, data, retInfo } = await collect_autoManualInit_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 浏览spu
export const collect_browse_post_ = async function(params) {
  const { success, data, retInfo } = await collect_browse_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类-复制
export const collect_copy_post_ = async function(params) {
  const { success, data, retInfo } = await collect_copy_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 分类详情
export const collect_mixmatch_detail_collectId_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await collect_mixmatch_detail_collectId_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 推送shopify
export const collect_pushShopify_post_ = async function(params, cb) {
  const { success, retInfo } = await collect_pushShopify_post(params)
  if (success) {
    cb()
    message.success(retInfo)
    return true
  } else {
    message.error(retInfo)
    return false
  }
}
